"use client";
import { customSanitize } from "@/utils/customSanitize";
import React from "react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { ContentTag } from "../../ContentTag/ContentTag";
import { Button } from "@/components/Button/Button";

export type GlossarCardElement = {
  title: string;
  content: string;
  link: string;
};

interface GlossarCardProps {
  element: GlossarCardElement;
  show_border_radius: boolean;
  show_box_shadow: boolean;
  showBox: boolean;
  skeleton?: boolean;
}

export const GlossarCard = ({
  element,
  show_border_radius,
  show_box_shadow,
  showBox,
  skeleton = false,
}: GlossarCardProps) => {
  const { getLabel } = useGlobalContext();
  const skeletonElementClass = skeleton ? "skeleton-element" : "";
  return (
    <article
      className={`glossar-card is-flex is-flex-direction-column is-justify-content-space-between p-5 ${showBox ? "is-box" : ""} h-100 ${show_border_radius && showBox ? "has-border-radius" : ""} ${show_box_shadow && showBox ? "has-box-shadow" : ""}`}
    >
      <div>
        <header>
          <span
            dangerouslySetInnerHTML={{ __html: customSanitize(element.title) }}
            className={`card-title is-block ${skeletonElementClass}`}
          />
        </header>
        <ContentTag
          content={element.content}
          extraClass={`${skeletonElementClass}`}
        />
      </div>

      {element.link && (
        <Button
          // className="mt-auto"
          type="secondary"
          href={element.link}
          target="_self"
          aria-label={getLabel("aria_label_postlink").replace(
            `"$posttitle"`,
            element.title,
          )}
          className={`${skeletonElementClass}`}
        >
          {getLabel("glossary_term_info")}
        </Button>
      )}
    </article>
  );
};
